import React from 'react';
import './AllArticles.css';
import GoToTop from "../Support/GoToTop"; // Global CSS import

const Eucharist = () => {
    return (
        <article className="article">
            <header className="header">
                <h1>Is the Eucharist Really the Body and Blood of Jesus?</h1>
                <p className="author">By Jakob Puckett</p>
            </header>

            <section>
                <p>
                    There is nothing more important in the Orthodox Christian life than receiving the Eucharist.
                    Each part of our liturgy and all other mysteries point to it, and we take it as often as we can.
                </p>
                <p>
                    Why is the Eucharist so important, and what is the source of our beliefs about it?
                </p>
                <p>
                    Simply put, Orthodox Christians believe the Eucharist truly is the body and blood of Jesus Christ, the incarnate Son of God, under the appearances of bread and wine. At each liturgy, Jesus’ once-for-all sacrifice is made present again so we can partake of it. And this belief comes straight from the Bible.
                </p>
            </section>

            <section>
                <h2>Jesus’ Words and the Last Supper</h2>
                <p>
                    Jesus tells a crowd that he is the new bread from heaven, and that eating this bread gives eternal life. When the crowd pushed back, Jesus doubled down: “Unless you eat the flesh of the Son of Man and drink his blood, you have no life in you…” (John 6:51–58).
                </p>
                <p>
                    Many followers took offense and left, and Jesus neither corrected nor consoled them (John 6:63–66).
                </p>
                <p>
                    At the last supper, Jesus gave the apostles bread and wine and said, “this is my body” and “this is my blood,” “do this in remembrance of me” (Luke 22, Matthew 26). The Greek word for “remembrance” implies a making-present of a past event.
                </p>
                <p>
                    Just as in the first passover, the new passover meal is not complete without eating the lamb.
                </p>
            </section>

            <section>
                <h2>Paul’s Teaching on the Eucharist</h2>
                <p>
                    Paul tells the Corinthians that because Christ, our passover lamb, was sacrificed, “let us keep the feast” (1 Cor. 5:7). This feast is “communion of the blood…and body of Christ” (1 Cor. 10:16–17).
                </p>
                <p>
                    Receiving the Eucharist unworthily is an offense against Christ himself, which can lead to sickness or death (1 Cor. 11:27–30).
                </p>
                <p>
                    When properly received, the Eucharist is the greatest way God works through the material world for our salvation.
                </p>
            </section>

            <section>
                <h2>Spiritual Life and Resurrection</h2>
                <p>
                    Through the Eucharist, we regain the connection to God’s life lost by Adam’s sin. Our spiritual life heralds our physical resurrection. Jesus promises, “I will raise him up at the last day” (John 6:54).
                </p>
            </section>

            <section>
                <h2>Early Church Witness</h2>
                <p>
                    Ignatius called the Eucharist “the medicine of immortality.” He wrote that false teachers “abstain from the Eucharist…because they do not confess that [it] is the flesh of our Savior Jesus Christ.”
                </p>
                <p>
                    Justin Martyr said the Eucharist is not “common bread and common drink,” but “is the flesh and blood of Jesus made flesh.” Athenagoras explained that because Christ is alive, it is wrong to call this cannibalism.
                </p>
                <p>
                    Just as many of Jesus’ followers “walked with him no more” (John 6:66), the Eucharist remained a lightning rod and litmus test as Christianity spread.
                </p>
            </section>

            <section>
                <h2>Conclusion</h2>
                <p>
                    Scripture and the early church are clear – the Eucharist is the body and blood of Jesus Christ himself. It makes present again Jesus’ once-for-all sacrifice, given for our sins and so that we may participate in his divine life.
                </p>
                <p>
                    Christ our passover lamb has been sacrificed – let us keep the feast!
                </p>
                <p className="author-note">
                    Jakob Puckett is a reader in the Coptic Orthodox Church.
                </p>
            </section>
            <GoToTop/>
        </article>
    );
};

export default Eucharist;